import {createContext, type ReactNode, use} from 'react'

export const PreviewUrlContext = createContext<string>('')

export function PreviewUrlProvider({value, children}: {value: string; children: ReactNode}) {
  return <PreviewUrlContext value={value}>{children}</PreviewUrlContext>
}

export function usePreviewUrl(): string {
  return use(PreviewUrlContext)
}
